import { Popover as muiPopover } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled, { css } from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontFamily } from 'stylesheet';
import { fontWeight, getSpacing, borderRadius } from 'stylesheetB2b';

export const Popover = muiStyled(muiPopover)<{ colors: ColormapInterface }>(({ colors }) => ({
  '& .MuiPaper-root': {
    backgroundColor: colors.languagesPopoverBackground,
  },
  '& .MuiPaper-rounded': {
    borderRadius: borderRadius.large,
  },
}));

export const MenuItem = styled.div<{ colors: ColormapInterface; isSelected: boolean }>`
  display: flex;
  align-items: center;
  height: ${getSpacing(8)};
  width: ${getSpacing(20)};
  padding: ${getSpacing(2)};
  ${({ colors, isSelected }) =>
    css`
      color: ${isSelected ? colors.languagesPopoverSelected : colors.defaultText};
      background-color: ${isSelected ? colors.languagesPopoverSelectedBackground : 'inherit'};
    `}
  font-weight: ${fontWeight.bold};
  font-family: ${fontFamily.main};
  cursor: pointer;
`;
